export const setLocalStorage = (key, payload) => {
  window.localStorage.setItem(key, JSON.stringify(payload));
};

export const getLocalStorage = (key) => {
  return JSON.parse(window.localStorage.getItem(key));
};
